import React from "react";
import { Card, Image, Button } from "react-bootstrap";
import styled from "styled-components";
import { FaLinkedin } from "react-icons/fa";
import photo_resume from "../img/photo_resume.webp";

export default () => {
  return (
    <Styles>
      <Card style={{ width: "18rem" }}>
        <Card.Header className="header">
          <h5 className="header-text">Linked</h5>
          <FaLinkedin className="header-icon" color=" #0676b3" size="1.5em" />
        </Card.Header>
        <Card.Body>
          <Image src={photo_resume} type="image/webp" className="photo" />
          <Card.Title>Ivy Pratiwi</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            Data Science & Analytics | Front End Web Development
          </Card.Subtitle>
          <Card.Text>BHP | QUT</Card.Text>
          <Button
            href="https://www.linkedin.com/in/ivypratiwi"
            target="_blank"
            variant="outline-primary"
            size="sm"
          >
            View Profile
          </Button>
        </Card.Body>
      </Card>
    </Styles>
  );
};

const Styles = styled.div`
  .header {
    display: inline-block;
    width: 100%;
    text-align: center;
  }
  .header-text,
  .header-icon {
    display: inline;
  }
  .header-icon {
    margin-left: 2px;
    margin-top: -5px;
  }
  .photo {
    display: inline;
    width: 35%;
    border-radius: 50%;
  }
  .text-muted {
    font-size: 0.8rem;
  }
  .card {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    margin-bottom: 50px;
    width: 50%;
  }
  .card-text {
    font-size: 0.8rem;
  }
  .card-body {
    text-align: center;
  }

  @media (min-width: 2200px) {
    .card-text {
      font-size: 0.9rem;
    }
    .card-subtitle {
      font-size: 1rem;
    }
    .card-header {
    }
    .card-title {
      margin-top: 5%;
    }
    .btn {
      font-size: 1rem;
    }
  }
`;
